import React, { memo, useEffect, useState } from 'react'
import { Helmet } from "react-helmet";
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';

type HelmetProps = {
    children: React.ReactNode,
    title?: string,
    withNameApp?: boolean
}

function Page({ children, title, withNameApp }: HelmetProps) {
    const {t} = useTranslation()
    const [currentTitle, setCurrentTitle] = useState('');
 

    const getTitle = () => {
        if (!withNameApp) return title ? t(title) : process.env.REACT_APP_NAME;
        return [...[title ? t(title) : ''], process.env.REACT_APP_NAME].join(' - ');
    };

    return (
        <>
            <Helmet>
                <title>{getTitle()}</title>
            </Helmet>

            {children}
        </>
    )
}

export default Page